import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col md:flex-row bg-gradient-to-br from-blue-100 to-blue-300" }
const _hoisted_2 = { class: "md:hidden flex items-center justify-between p-4" }
const _hoisted_3 = {
  key: 0,
  class: "fixed inset-0 bg-blue-200 p-6 z-50 flex flex-col space-y-4 text-xl"
}

import { ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'header-view',
  setup(__props) {

const isOpen = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "text-3xl font-bold" }, "ECLIPSE BOUNDARIES", -1)),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value)),
        class: "text-3xl focus:outline-none"
      }, " ☰ ")
    ]),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = false)),
                class: "self-end text-3xl"
              }, "✕"),
              _cache[3] || (_cache[3] = _createElementVNode("ul", { class: "space-y-4 text-xl" }, [
                _createElementVNode("li", { class: "hover:underline cursor-pointer" }, "AGENDA"),
                _createElementVNode("li", { class: "hover:underline cursor-pointer" }, "UPDATES")
              ], -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"md:w-2/3 w-full flex items-center justify-center\" data-v-a8f2d8d6><img src=\"path-to-your-image.jpg\" alt=\"Artists\" class=\"max-w-full h-auto object-cover md:h-auto md:max-h-screen\" data-v-a8f2d8d6></div><div class=\"hidden md:flex md:w-1/3 flex-col justify-center items-start p-8\" data-v-a8f2d8d6><h1 class=\"text-4xl font-bold mb-8\" data-v-a8f2d8d6>ECLIPSE BOUNDARIES</h1><ul class=\"space-y-4 text-xl\" data-v-a8f2d8d6><li class=\"group relative cursor-pointer\" data-v-a8f2d8d6><span class=\"group-hover:text-blue-600\" data-v-a8f2d8d6>AGENDA</span><span class=\"absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 group-hover:w-full transition-all duration-500\" data-v-a8f2d8d6></span></li><li class=\"group relative cursor-pointer\" data-v-a8f2d8d6><span class=\"group-hover:text-blue-600\" data-v-a8f2d8d6>UPDATES</span><span class=\"absolute bottom-0 left-0 w-0 h-0.5 bg-blue-600 group-hover:w-full transition-all duration-500\" data-v-a8f2d8d6></span></li></ul></div>", 2))
  ]))
}
}

})